import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { LotacaoAtribuicaoDto } from '../dtos/lotacoes-atribuicoes/lotacao-atribuicao-dto';
import { UrlService } from './url.service';

@Injectable({
  providedIn: 'root'
})
export class LotacaoAtribuicaoService {

  constructor(private http: HttpClient, private url: UrlService) { }

  listarLotacoesAtribuicoes(pessoaId: number): Observable<LotacaoAtribuicaoDto> {
    let params = new HttpParams().set('pessoaId', pessoaId);

    return this.http.get<LotacaoAtribuicaoDto>(this.url.url('lotacoes-atribuicoes'), { params: params })
    .pipe(map((val) => {
      val.dataInicial = new Date(val.dataInicial);
      val.dataFinal = val.dataFinal ? new Date(val.dataFinal) : null;
      return val;
    }));
  }

  consultarLotacaoAtribuicao(lotacaoAtribuicaoId: number): Observable<LotacaoAtribuicaoDto> {
    return this.http.get<LotacaoAtribuicaoDto>(this.url.url(`lotacoes-atribuicoes/${lotacaoAtribuicaoId}`))
    .pipe(map((val) => {
      val.dataInicial = new Date(val.dataInicial);
      val.dataFinal = val.dataFinal ? new Date(val.dataFinal) : null;
      return val;
    }));
  }

  probableEmploymentRelationship(patientId: number): Observable<LotacaoAtribuicaoDto> {
    let params = new HttpParams().set('pacienteId', patientId);

    return this.http.get<LotacaoAtribuicaoDto>(this.url.url(`lotacoes-atribuicoes/provavel`), { params: params })
    .pipe(map((val) => {
      val.dataInicial = new Date(val.dataInicial);
      val.dataFinal = val.dataFinal ? new Date(val.dataFinal) : null;
      return val;
    }));
  }
}
